import styled from "styled-components";

export const PrincipalDiv = styled.div`
  margin-bottom: 2%;
  background-color: #15191a;
  padding: 6rem 0;
  color: white;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ContentDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 10%;
  justify-content: space-between;
  @media (max-width: 1000px) {
    padding: 0 5%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 10px;
    color: white;
  }
  p {
    font-size: 16px;
    margin: 5px 0;
    color: white;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  width: 45%;

  @media (max-width: 1000px) {
    align-items: center;
  }
`;

export const Logo = styled.img`
  height: 90px;
  width: auto;
  object-fit: contain;
  display: block;
  margin-right: 15px; /* Usar px em vez de % para evitar recalculos */
  margin-top: 10px;

  @media (max-width: 800px) {
    height: 80px;
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const AddressDiv = styled.div`
  padding: 10px;
  min-height: 100px;
  border-right: 1px solid white;

  @media (max-width: 800px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid white;
    padding: 5px; /* Reduzir padding */
  }
`;

export const ContactDiv = styled.div`
  padding: 10px;
  margin-left: 10px;
  width: 45%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  @media (max-width: 1000px) {
    align-items: center;
  }
`;

export const IconsDiv = styled.div`
  padding: 2px;
  display: flex;
  gap: 10px;
  margin-top: 10px;

  .icons {
    width: 1.5em;
    height: 1.5em;
    cursor: pointer;

    @media (max-width: 800px) {
      width: 2.0em;
      height: 2.0em;
    }
  }
`;

export const IconArea= styled.div`
  background-color: #e5b930;
  border-radius: 100%;
  margin: 0 10px 10px;
  padding: 5%;
  display: flex;
  align-items: center;

`;

export const ContentDivText = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
`;

export const CopyRight = styled.div`
  text-align: center;
  margin-top: 2%;
  color: var(--purple-dark);
  font-weight: bold;
  background-color: white;

  p {
    margin: 5px 0;
    color: var(--purple-dark);
  }

  strong {
    color: var(--orange);
  }

  @media (max-width: 1450px) {
    margin: 2% 0;
  }
`;